/**
 * Idle warning (identity request, NFR X-07): polls GET /v1/identity/session/status (does not extend the idle
 * window) and warns two minutes before idle expiry. "Stay signed in" calls /v1/identity/me which touches
 * the session. The server is authoritative; this timer is a courtesy only.
 */
import { useEffect, useState } from 'react';
import { Button } from '@qm/ui';
import { useApp } from '../lib/app-context';
import { bff } from '../lib/bff';

export const WARN_BEFORE_MS = 2 * 60_000;
export function shouldWarn(idleExpiresAt: string | null, now: number): boolean {
  if (!idleExpiresAt) return false;
  const left = new Date(idleExpiresAt).getTime() - now;
  return left > 0 && left <= WARN_BEFORE_MS;
}

export function IdleWarning() {
  const { t, me } = useApp();
  const [expires, setExpires] = useState<string | null>(null);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!me) return;
    let live = true;
    const poll = () => bff<{ idleExpiresAt: string }>('/v1/identity/session/status').then((s) => { if (live) setExpires(s.idleExpiresAt); }, () => undefined);
    void poll();
    const a = setInterval(poll, 60_000);
    const b = setInterval(() => setNow(Date.now()), 15_000);
    return () => { live = false; clearInterval(a); clearInterval(b); };
  }, [me]);
  if (!shouldWarn(expires, now)) return null;
  return (
    <div className="qm-idle" role="alert">
      <span>{t('shell.idle.warning')}</span>
      <Button onClick={() => void bff<{ session: { idleExpiresAt: string } }>('/v1/identity/me').then((m) => setExpires(m.session.idleExpiresAt), () => undefined)}>{t('shell.idle.stay')}</Button>
    </div>
  );
}
